import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AnswersConfig } from '@core/models/built/procedure-step-config.model';
import { ProcedureStepType } from '@core/models/built/procedure-step-type.enum';
import { InputJson } from '@core/models/built/session-step-value-json.model';
import { SessionStep } from '@core/models/session.model';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  templateUrl: './choice-report.component.html'
})
export class ChoiceReportComponent implements OnChanges {

  @Input() step!: SessionStep;


  private step$$ = new BehaviorSubject<SessionStep>(this.step);
  step$ = this.step$$.asObservable();

  answers$ = this.step$.pipe(map(step => (step.procedureStep?.config as AnswersConfig)?.answers || []));
  checkedAnswers$ = this.step$.pipe(map(step => step.values?.map(v => (v.value as InputJson).input) || []));

  checkedIcon$ = this.step$.pipe(map(step => step.type === ProcedureStepType.inputSingleChoice ? 'radio_button_checked' : 'check_box'));
  unCheckedIcon$ = this.step$.pipe(map(step => step.type === ProcedureStepType.inputSingleChoice ? 'radio_button_unchecked' : 'check_box_outline_blank'));

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.step) {
      this.step$$.next(changes.step.currentValue);
    }
  }

}
